export enum ThemeMode {
  auto = 'auto',
  dark = 'dark',
  light = 'light',
}
